var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    [
      _c("el-header", { staticClass: "header" }, [_c("HeaderComponent")], 1),
      _vm._v(" "),
      _c(
        "el-container",
        [
          _c("SideBarComponent"),
          _vm._v(" "),
          _c(
            "el-main",
            { staticClass: "main" },
            [
              _c("SubTitleComponent", { attrs: { title: _vm.title } }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "box" },
                [
                  _c(
                    "el-row",
                    { staticClass: "row", attrs: { gutter: 20 } },
                    [
                      _c("el-col", { attrs: { span: 14 } }, [
                        _c("div", { staticClass: "img" }, [
                          _vm.media_type == 0
                            ? _c("img", { attrs: { src: _vm.src, alt: "" } })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.media_type == 1
                            ? _c("video", {
                                attrs: { src: _vm.src, alt: "", controls: "" }
                              })
                            : _vm._e()
                        ])
                      ]),
                      _vm._v(" "),
                      _c("el-col", { attrs: { span: 10 } }, [
                        _c("div", { staticClass: "list" }, [
                          _c("div", { staticClass: "item title" }, [
                            _vm._v("参数")
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "item" }, [
                            _c("div", { staticClass: "label" }, [
                              _vm._v("创作时间")
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "content" }, [
                              _vm._v(_vm._s(_vm.date))
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "item" }, [
                            _c("div", { staticClass: "label" }, [
                              _vm._v("空间类型")
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "content" }, [
                              _vm._v(_vm._s(_vm.space_type))
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "item" }, [
                            _c("div", { staticClass: "label" }, [
                              _vm._v("创作风格")
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "content" }, [
                              _vm._v(_vm._s(_vm.style_type))
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "item" }, [
                            _c("div", { staticClass: "label" }, [
                              _vm._v("AI大模型")
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "content" }, [
                              _vm._v(_vm._s(_vm.model_name))
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "item" }, [
                            _c("div", { staticClass: "label" }, [
                              _vm._v("风格强度")
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "content" }, [
                              _vm._v(_vm._s(_vm.style_intensity))
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "item" }, [
                            _c("div", { staticClass: "label" }, [
                              _vm._v("描述强度")
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "content" }, [
                              _vm._v(_vm._s(_vm.describing))
                            ])
                          ])
                        ])
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { staticClass: "tool", attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                icon: "el-icon-picture-outline",
                                plain: ""
                              },
                              on: {
                                click: function($event) {
                                  return _vm.toPath("/effectsave")
                                }
                              }
                            },
                            [_vm._v("生成新的效果图")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                icon: "el-icon-picture",
                                plain: ""
                              },
                              on: {
                                click: function($event) {
                                  return _vm.toPath("/effectvideo")
                                }
                              }
                            },
                            [_vm._v("图生视频")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                icon: "el-icon-first-aid-kit",
                                plain: ""
                              },
                              on: {
                                click: function($event) {
                                  return _vm.toPath("/effectaiedit")
                                }
                              }
                            },
                            [_vm._v("AI改图")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                icon: "el-icon-download",
                                plain: ""
                              },
                              on: { click: _vm.toDownload }
                            },
                            [_vm._v("下载")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5833cf65", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5833cf65","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Effect/Detail.vue
// module id = null
// module chunks = 